import React from 'react';
import { IconProps } from '.';

const SvgCheckBold = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M22.535 7.085 8.84 20.148l-7.452-8.232 2.224-2.014 5.386 5.95L20.465 4.915l2.07 2.17Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCheckBold;
